// extracted by mini-css-extract-plugin
export default {"app":"PlacesInput_app__FmI2d","inputBox":"PlacesInput_inputBox__yGvOR","modal":"PlacesInput_modal__8Z6GB","app2":"PlacesInput_app2__AZmcS","app3":"PlacesInput_app3__PLUxr"};